<template>

    <div class="share-card">

        <span>

            <h2 class="cf-title-3 sharing-title">{{ $t('cleaning_cards_sharing_cta') }}</h2>

            <p class="cf-text sharing-text">{{ $t('cleaning_cards_sharing_text') }}</p>

        </span>

        <div class="share-card-btn-container">

            <img v-if="$mq === 'lg'" class="share-card-foxy" src="/img/foxy/middle-smile.png">

            <button class="btn btn-dark" @click="share">{{ $t('cleaning_cards_sharing_cta') }}</button>

        </div>

    </div>

</template>

<script>

import Storage from '@/helpers/storage'

export default {

    name: 'card-template-sharing',

    methods: {

        share() {

            Storage.setItem('usedSharingCard', true)
            this.$emit('share')
        }
    }
}

</script>

<style lang="scss" scoped>

.share-card {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    background-color: $blue;
    border-radius: 12px;
    padding: 24px;
    align-items: center;
    justify-content: space-between;

    color: $white;
    background-image: url('/img/cards/background-share-mobile.svg');
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: cover;
    @media screen and (min-width: $above-tablet-length) {
        background-image: url('/img/background/fetch-desktop.svg');
    }
}

.sharing-text {
    margin-top: 8px;
}

.share-card-btn-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 275px;
    position: relative;
}

.share-card-foxy {
    position: absolute;
    top: -66px;
    width: 100%;
}

</style>
